export const calculateRemainingTime = (expiration) => {
  const currTime = new Date().getTime();
  const expTime = +expiration;
  const remTime = expTime - currTime;
  return remTime;
};

export const retrieveStoredTokens = () => {
  const storedToken = localStorage.getItem("authTokenPIXELBAY");
  const expiresAt = localStorage.getItem("expiresAtPIXELBAY");
  const firstName = localStorage.getItem("firstNamePIXELBAY");
  const lastName = localStorage.getItem("lastNamePIXELBAY");

  const remainingTime = calculateRemainingTime(expiresAt);
  
  if (remainingTime < 100) {
    localStorage.removeItem("authTokenPIXELBAY");
    localStorage.removeItem("expiresAtPIXELBAY");
    localStorage.removeItem("firstNamePIXELBAY");
    localStorage.removeItem("lastNamePIXELBAY");

    return null;
  }
  if (
    storedToken !== null &&
    expiresAt !== null &&
    firstName !== null &&
    lastName !== null
  ) {
    return {
      token: storedToken,
      timeLeft: remainingTime,
      firstName: firstName,
      lastName: lastName,
    };
  }
  else{
    return null;
  }
};
